import { ChatMessageStatus } from '@/types/schema.generated'

export const chatMessageStatusString: Record<ChatMessageStatus, string> = {
  [ChatMessageStatus.Unread]: '未読',
  [ChatMessageStatus.Unreplied]: '未返信',
  [ChatMessageStatus.Replied]: '返信済み',
}

export const allChatMessageStatuses: ChatMessageStatus[] = [
  ChatMessageStatus.Unread,
  ChatMessageStatus.Unreplied,
  ChatMessageStatus.Replied,
]
